// import { $api } from '@shared/api';
// import {
//     IGetRootFilesApiResponse,
//     IUseGetFilesResponse,
// } from '@widgets/Files/model/types/api.interface';
//
// export const getRootFiles = async () => {
//     // @ts-ignore
//     const url = routable.getRoute('getFiles');
//
//     const res = await $api.get<IGetRootFilesApiResponse<IUseGetFilesResponse>>(url);
//
//     if (res.status === 'error' || res.data === null) {
//         throw new Error(res.message || 'Failed to load files');
//     }
//     console.log('res: ', res);
//     return res;
// };

import { $api } from '@shared/api';
import {
    IGetRootFilesApiResponse,
    IUseGetFilesResponse,
} from '@widgets/Files/model/types/api.interface';
import { TFolderId } from '@widgets/Files/model/types/folderId.type';

export const getRootFiles = async (
    folderId: TFolderId | null = null
): Promise<IGetRootFilesApiResponse<IUseGetFilesResponse>> => {
    // @ts-ignore
    let getFilesUrl = routable.getRoute('getFiles');
    if (folderId != null && folderId > 0) {
        getFilesUrl = `${getFilesUrl}/${folderId}`;
    }

    try {
        const res = await $api.get<IGetRootFilesApiResponse<IUseGetFilesResponse>>(getFilesUrl);
        return res.data;
    } catch (error: any) {
        console.error('get root files failed:', error);
        // return {
        //     status: 'error',
        //     data: null,
        //     message: error.message,
        // };
        return (
            error?.response?.data || {
                status: 'error',
                data: null,
                message: error.message,
            }
        );
    }
};
